import * as Axios from 'axios';
import {BASE_URL, token} from '../utils/const.js';
import {getLanguage} from 'react-switch-lang';

const headers = {
  Authorization: 'Bearer ' + token,
  Accept: '*/*',
  'Access-Control-Allow-Origin': '*',
  'accept-Language': getLanguage()
};

Axios.defaults.baseURL = BASE_URL;
Axios.defaults.headers = headers;

export default {
  get: Axios.get,
  post: Axios.post,
  put: Axios.put,
  delete: Axios.delete,
};
